export type ExpenseIntakeActionType =
  | 'capture_fuel'
  | 'capture_toll'
  | 'capture_expense'
  | 'capture_travel'
  | 'procurement_delivery_note'
  | 'procurement_supplier_invoice'
  | 'procurement_supplier_quote'
  | 'procurement_grn'
  | 'procurement_purchase_return'
  | 'procurement_supplier_credit';

export function inferActionType(entryType: string): ExpenseIntakeActionType {
  const normalized = entryType.trim().toLowerCase();
  if (normalized === 'fuel') return 'capture_fuel';
  if (normalized === 'toll') return 'capture_toll';
  if (normalized === 'travel') return 'capture_travel';
  if (normalized === 'delivery_note') return 'procurement_delivery_note';
  if (normalized === 'supplier_invoice') return 'procurement_supplier_invoice';
  if (normalized === 'supplier_quote') return 'procurement_supplier_quote';
  if (normalized === 'grn') return 'procurement_grn';
  if (normalized === 'purchase_return') return 'procurement_purchase_return';
  if (normalized === 'supplier_credit') return 'procurement_supplier_credit';
  return 'capture_expense';
}
